var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"text":"","color":"info","disabled":!_vm.savable,"loading":_vm.saving},on:{"click":_vm.save}},[_vm._v("Speichern ")])
}
var staticRenderFns = []

export { render, staticRenderFns }